import type { BadgeTone } from '../atoms/Badge/Badge.types';

/** Short localised date ("9 Oct 2026"); '—' for a missing or invalid value. */
export function formatDate(iso: string | null | undefined, language: string): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(language, { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
}

/** Short localised date and time ("9 Oct 2026, 14:05"); '—' for a missing or invalid value. */
export function formatDateTime(iso: string | null | undefined, language: string): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(language, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

/** Licence status → Badge tone (the Badge always carries the status as text too). */
export function licenseStatusTone(status: string): BadgeTone {
  if (status === 'active') return 'success';
  if (status === 'expired') return 'warning';
  return 'danger';
}

/** Localised number with up to `digits` decimals. */
export function formatNumber(value: number, language: string, digits = 0): string {
  return new Intl.NumberFormat(language, { maximumFractionDigits: digits }).format(value);
}
